module.exports = __webpack_public_path__ + "img/process-icon-3.d1012d7c.svg";